import React, {useState} from "react";
import styles from "./choose-cards.module.css";
import {Page} from "../../components/page/page";
import CardBack from "./back.png";
import {cardImages} from "./images_data";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setCards} from "../../store/stateSlice";

const getRandomImage = (exclude) => {
  let idx = Math.floor(Math.random() * cardImages.length);
  while (exclude.includes(idx)) {
    idx = Math.floor(Math.random() * cardImages.length);
  }
  return idx;
};

const ChooseCardsPage = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedCards, setSelectedCards] = useState({});

  const handleOnCardClick = (cardIdx) => {
    if (Object.keys(selectedCards).length >= 3) {
      return;
    }

    if (Object.keys(selectedCards).includes(cardIdx.toString())) {
      return;
    }

    const idx = getRandomImage(Object.values(selectedCards));
    const updatedCards = { ...selectedCards, ...{ [cardIdx]: idx } };
    setSelectedCards(updatedCards);

    if (Object.keys(updatedCards).length === 3) {
      setTimeout(() => {
        dispatch(setCards(Object.values(updatedCards)));
        navigate("../result");
      }, 500);
    }
  };

  const title = () => {
    if (Object.keys(selectedCards).length === 0) {
      return "Ask a question about love, then choose 3 cards";
    } else if (Object.keys(selectedCards).length === 1) {
      return "Please choose 2 more cards";
    } else {
      return "Please choose 1 more card";
    }
  };

  return (
    <div className={styles.container_page}>
      <Page title={title()} hideContinueButton={true}>
        <div className={styles.cards_container}>
          {[...Array(16)].map((el, i) => (
            <img
              key={i}
              className={styles.card_back_image}
              src={
                Object.keys(selectedCards).includes(i.toString())
                  ? cardImages[selectedCards[i]]
                  : CardBack
              }
              alt={"card-" + i}
              onClick={() => handleOnCardClick(i)}
            />
          ))}
        </div>
      </Page>
    </div>
  );
};

export { ChooseCardsPage };
